import { KycStatus, SyncDTO } from '../../store/slices/authSlice';

// Defines allowed KYC status values for validation
const allowedKycStatuses: KycStatus[] = [
  'NOT_VERIFIED', 'NOT_STARTED', 'PENDING', 'REVIEW', 'RENEW', 'APPROVED', 'DECLINED', null,
];

// Type guard to validate the KYC status
function isValidKycStatus(value: any): value is KycStatus {
  return allowedKycStatuses.includes(value);
}

// Processes the sync response and restores account selection
export function getAuthStateFromLocalStorage(res: SyncDTO) {
  // Single line comment: Get user preference for active account
  const storedSelectedId = localStorage.getItem('selectedSteamAccountId');

  // Validate KYC status from nested user object or default to null
  const safeKycStatus: KycStatus = isValidKycStatus(res.user?.kycStatus) ? res.user.kycStatus : null;

  let finalSelectedAccount = res.selectedSteamAccount;

  // If a user manually switched an account before, try to restore that selection
  if (storedSelectedId && res.steamAccounts) {
    const found = res.steamAccounts.find(a => a.id === storedSelectedId);
    if (found) {
      finalSelectedAccount = found;
    }
  }

  return {
    selectedSteamAccount: finalSelectedAccount,
    steamAccounts: res.steamAccounts || [],
    userMail: res.user?.userMail ?? null,
    role: res.user?.role ?? null,
    kycStatus: safeKycStatus,
    signUpStep: res.user?.signUpStep ?? 'NONE',
    user: res.user,
    wallet: res.wallet,
    fees: res.fees,
    paymentAccounts: res.paymentAccounts,
    statistics: res.statistics,
    fcm: res.fcm,
  };
}